"use strict";

var _interopRequireDefault = require("/home/sandeep/Work/EIOSYS/CONA-CRM/Admin/Cona-Electrical-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateAgent = exports.getAgentsForSalesAndRegionalRoles = exports.getAgentsBranchWise = exports.getAgents = exports.getAgentById = exports.getAgentBranchWiseCount = exports.deleteAgent = exports.defaultAgentData = exports.createAgent = exports.agentsCount = void 0;
var _request = _interopRequireDefault(require("@/utils/request"));
const defaultAgentData = exports.defaultAgentData = {
  id: 0,
  enabled: true,
  name: '',
  code: ''
};
const getAgents = params => (0, _request.default)({
  url: '/agents',
  method: 'get',
  params
});
exports.getAgents = getAgents;
const getAgentsBranchWise = params => (0, _request.default)({
  url: '/agents/branch-wise',
  method: 'get',
  params
});
exports.getAgentsBranchWise = getAgentsBranchWise;
const getAgentBranchWiseCount = params => (0, _request.default)({
  url: '/agents/branch-wise-count',
  method: 'get',
  params
});
exports.getAgentBranchWiseCount = getAgentBranchWiseCount;
const getAgentsForSalesAndRegionalRoles = params => (0, _request.default)({
  url: '/agents/filtered-for-agents',
  method: 'get',
  params
});
exports.getAgentsForSalesAndRegionalRoles = getAgentsForSalesAndRegionalRoles;
const getAgentById = id => (0, _request.default)({
  url: `/agents/${id}`,
  method: 'get'
});
exports.getAgentById = getAgentById;
const updateAgent = (id, data) => (0, _request.default)({
  url: `/agents/${id}`,
  method: 'patch',
  data
});
exports.updateAgent = updateAgent;
const deleteAgent = id => (0, _request.default)({
  url: `/agents/${id}`,
  method: 'delete'
});
exports.deleteAgent = deleteAgent;
const createAgent = data => (0, _request.default)({
  url: '/agents',
  method: 'post',
  data
});
exports.createAgent = createAgent;
const agentsCount = params => (0, _request.default)({
  url: '/agents/count',
  method: 'get',
  params
});
exports.agentsCount = agentsCount;